import { ComponentProps } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { PhoneField } from '@/features/update-user-information'
import { PhoneVerificationButton } from '@/features/verify-identity'
import { isNilOrEmptyString } from '@/shared/lib'

type Props = Pick<ComponentProps<typeof PhoneVerificationButton>, 'onSuccess'>

export const PhoneVerificationField = ({ onSuccess }: Props) => {
  const { control } = useFormContext()

  const phoneNumber = useWatch({
    control,
    name: 'phoneNumber',
  })

  const isVerified = !isNilOrEmptyString(phoneNumber)

  return (
    <div className="space-y-2">
      <PhoneField />
      <PhoneVerificationButton onSuccess={onSuccess} disabled={isVerified}>
        {isVerified ? '휴대폰 본인인증 완료' : '휴대폰 본인인증'}
      </PhoneVerificationButton>
    </div>
  )
}
